import { Link, NavLink } from "react-router-dom";
import { Phone, KeyRound, Menu, X } from "lucide-react";
import { useState } from "react";
import { Button } from "@/components/ui/button";
import { useLang } from "@/i18n/LanguageContext";
import { LanguageSwitcher } from "./LanguageSwitcher";
import { site } from "@/config/site";

export const Header = () => {
  const { t } = useLang();
  const [open, setOpen] = useState(false);

  const navLinks = [
    { to: "/", label: t("nav.home") },
    { to: "/leistungen", label: t("nav.services") },
    { to: "/probleme", label: t("nav.probleme") },
    { to: "/bezirke", label: t("nav.bezirke") },
    { to: "/preise", label: t("nav.preise") },
    { to: "/ratgeber", label: t("nav.ratgeber") },
    { to: "/kontakt", label: t("nav.contact") },
  ];

  return (
    <header className="fixed top-0 inset-x-0 z-50 backdrop-blur-md bg-background/90 border-b border-border">
      <div className="container flex items-center justify-between h-16">
        <Link to="/" className="flex items-center gap-2 font-display text-xl md:text-2xl tracking-wider">
          <span className="grid place-items-center w-9 h-9 rounded-md bg-gradient-accent shadow-accent-glow">
            <KeyRound className="w-5 h-5 text-accent-foreground" />
          </span>
          <span className="text-primary leading-none">SCHLÜSSEL<span className="text-accent">DIENST</span></span>
        </Link>

        <nav className="hidden lg:flex items-center gap-7">
          {navLinks.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              end={l.to === "/"}
              className={({ isActive }) =>
                `text-sm font-medium transition-colors ${isActive ? "text-accent" : "text-foreground/70 hover:text-accent"}`
              }
            >
              {l.label}
            </NavLink>
          ))}
        </nav>

        <div className="hidden md:flex items-center gap-3">
          <LanguageSwitcher />
          <a href={site.phoneHref} className="hidden xl:flex items-center gap-2 text-sm font-semibold text-primary">
            <Phone className="w-4 h-4 text-accent" /> {site.phoneDisplay}
          </a>
          <Button variant="emergency" size="sm" asChild>
            <a href={site.phoneHref} className="gap-2"><Phone className="w-4 h-4" /> {t("cta.callNow")}</a>
          </Button>
        </div>

        <button onClick={() => setOpen(!open)} className="md:hidden p-2" aria-label="Menu">
          {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
        </button>
      </div>

      {open && (
        <div className="md:hidden border-t border-border bg-background">
          <div className="container py-4 flex flex-col gap-2">
            {navLinks.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                end={l.to === "/"}
                onClick={() => setOpen(false)}
                className={({ isActive }) =>
                  `py-2 text-base font-medium ${isActive ? "text-accent" : "text-foreground/80"}`
                }
              >
                {l.label}
              </NavLink>
            ))}
            <div className="flex items-center justify-between pt-3 border-t border-border">
              <LanguageSwitcher />
              <Button variant="emergency" size="sm" asChild>
                <a href={site.phoneHref} className="gap-2"><Phone className="w-4 h-4" /> {t("cta.callNow")}</a>
              </Button>
            </div>
          </div>
        </div>
      )}
    </header>
  );
};